(function () {
  'use strict';

  angular.module('app').service('ClientModalService', ClientModalService);

  ClientModalService.$inject = ['ModalService'];

  function ClientModalService(ModalService) {
    let service = {
      openClientFastCreateModal: openClientFastCreateModal,
    };

    return service;

    ////////////////////////////

    function openClientFastCreateModal(item, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/clients/modals/client-fast-create-modal.html',
        controller: ClientFastCreateModalCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        let preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      ClientFastCreateModalCtrl.$inject = ['$element', 'item', 'successCallback'];
    }

    function ClientFastCreateModalCtrl($element, item, successCallback) {
      let vm = this;

      vm.item = item;

      vm.modalTitle = 'NEW_CLIENT';

      if (vm.item.id) {
        vm.modalTitle = 'EDIT_CLIENT';
      }

      vm.onSavedItem = function (item) {
        successCallback(item);
        $element.modal('hide');
      };

      vm.onCanceledItem = function (item) {
        $element.modal('hide');
      };
    }
  }
})();
